import { Icon } from '@/components'
import { useCountdownV2 } from '@/hooks'
import { useCountdown } from '@/hooks/use-count-down'
import { useWindowSize } from '@/hooks/use-window-size'
import { getVND } from '@/utils/helpers'
import { Box, Stack, Typography } from '@mui/material'
import Collapse from '@mui/material/Collapse'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import React, { useEffect, useState } from 'react'

const commonColor = '#FF421D'

export type TProductItem = {
  product_name: string
  add_qty: number
  checkout_price: number
  final_price: number
  product_image: string
  link: string
  attributes?: {
    label: string
    value: string
    option_id: string
    option_value: string
  }[]
}
//#region WrapGlobalFixedProduct
type TWrapGlobalFixedProduct = {
  data: TProductItem[]
  total: number
  expireAfter: number
  onExpire?: () => void
  content?: {
    flagTitle?: React.ReactNode
    flagTitleMobile?: React.ReactNode
    titleOffer?: React.ReactNode
    buttonSubmit?: React.ReactNode
  }
}
export const WrapGlobalFixedProduct = ({ data, total, expireAfter, content }: TWrapGlobalFixedProduct) => {
  // const { count, start, reset } = useCountdownV2({
  //   initialValue: expireAfter,
  //   onComplete: onExpire,
  // })
  const [showOffer, setShowOffer] = useState(true)
  const { isMobile } = useWindowSize()

  // Sync countdown khi expireAfter thay đổi (từ tab khác hoặc re-calculate)
  // useEffect(() => {
  //   if (expireAfter > 0) {
  //     // reset()
  //     start()
  //   }
  // }, [expireAfter, reset, start])

  // useEffect(() => {
  //   if (count <= 0) {
  //     onExpire && onExpire()
  //   }
  // }, [count, onExpire])

  // const isOutOfTime = count <= 0

  // if (isOutOfTime) return null
  return (
    <Box sx={{ position: 'relative' }}>
      <FlagOffer
        showOffer={showOffer}
        setShowOffer={setShowOffer}
        count={expireAfter}
        content={{ desktop: content?.flagTitle, mobile: content?.flagTitleMobile }}
      />
      <Collapse timeout={isMobile ? 500 : undefined} in={showOffer} orientation="horizontal">
        <Box
          sx={{
            padding: 0.5,
            backgroundColor: commonColor,
            borderRadius: '0 0 0 8px',
          }}
        >
          <Stack
            gap={2}
            sx={{
              padding: 2,
              backgroundColor: 'primary.contrastText',
              borderRadius: '4px 0 0 0',
              color: 'primary.main',
              width: {
                xs: 'min(90vw, 320px)',
                sm: '380px',
                md: '430px',
              },
            }}
          >
            {/* title */}
            {content?.titleOffer || <TitleOffer total={total} />}
            {/* list product */}
            <Stack
              gap={1}
              sx={{
                maxHeight: { xs: '40vh', md: '30vh' },
                overflow: 'auto',
                '&::-webkit-scrollbar': {
                  width: '0px',
                },
                '&::-webkit-scrollbar-track': {
                  background: '#fff',
                },
                // '&::-webkit-scrollbar-thumb': {
                //   background: '#252422',
                // },
              }}
            >
              {data?.map((item, index) => {
                return <ProductItem key={index} item={item} />
              })}
            </Stack>
          </Stack>
          {/* button submit */}
          {content?.buttonSubmit}
        </Box>
      </Collapse>
    </Box>
  )
}

//#region Flag Offer
const FlagOffer = ({
  showOffer,
  setShowOffer,
  count,
  content,
}: {
  showOffer: boolean
  setShowOffer: React.Dispatch<React.SetStateAction<boolean>>
  count: number
  content?: { desktop?: React.ReactNode; mobile?: React.ReactNode }
}) => {
  const { isMobile } = useWindowSize()
  return (
    <>
      <Collapse in={isMobile && !showOffer} orientation="horizontal">
        <Stack
          gap={{ xs: 0.5, md: 1 }}
          sx={{
            padding: '6px 8px 8px',
            position: 'absolute',
            top: 0,
            left: { xs: 0, sm: 2 },
            transform: 'translateX(-100%)',
            width: 'fit-content',
            backgroundColor: commonColor,
            borderRadius: '8px 0 0 8px',
            color: 'primary.contrastText',
            cursor: 'pointer',
          }}
          onClick={() => setShowOffer(!showOffer)}
        >
          <Icon.ArrowRight
            sx={{
              fontSize: '20px',
              transform: showOffer ? 'rotate(0deg)' : 'rotate(180deg)',
              transition: 'transform 0.3s',
            }}
          />
          <Typography variant="body2" fontWeight={300} whiteSpace={'nowrap'}>
            {content?.mobile || (
              <>
                Ưu đãi <Box component={'br'} /> chỉ còn
              </>
            )}
          </Typography>
          <Typography sx={{ fontSize: { xs: '1rem', md: '1.15rem', xl: '1.25rem' }, maxWidth: '54px' }}>
            {Math.floor(count / 60)
              ?.toString()
              .padStart(2, '0')}
            :{(count % 60).toString().padStart(2, '0')}
          </Typography>
        </Stack>
      </Collapse>
      <Stack
        direction={{
          xs: 'row',
          sm: 'column',
        }}
        alignItems={{
          xs: 'center',
          sm: 'unset',
        }}
        gap={{ xs: 0.5, md: 1 }}
        sx={{
          padding: {
            xs: '6px 8px 2px',
            md: '8px 12px 12px',
          },
          position: 'absolute',
          top: 0,
          left: { xs: 0, sm: 2 },
          transform: {
            xs: 'translateY(-100%)',
            sm: 'translateX(-100%)',
          },
          width: {
            xs: '100%',
            sm: 'fit-content',
          },
          backgroundColor: commonColor,
          borderRadius: {
            xs: '8px 0 0 0',
            sm: '8px 0 0 8px',
          },
          color: 'primary.contrastText',
          cursor: 'pointer',
          overflow: 'hidden',
        }}
        onClick={() => setShowOffer(!showOffer)}
      >
        <Icon.ArrowRight
          sx={{
            fontSize: { xs: '14px', sm: '18px', md: '24px' },
            transform: showOffer ? 'rotate(0deg)' : 'rotate(180deg)',
            transition: 'transform 0.3s',
          }}
        />
        <Typography variant="body2" fontWeight={300} whiteSpace={'nowrap'}>
          {content?.desktop || (
            <>
              Ưu đãi <Box component={'br'} sx={{ display: { xs: 'none', sm: 'block' } }} /> chỉ còn
            </>
          )}
        </Typography>
        <Typography sx={{ fontSize: { xs: '1rem', md: '1.15rem', xl: '1.25rem' }, maxWidth: '54px' }}>
          {Math.floor(count / 60)
            ?.toString()
            .padStart(2, '0')}
          :{(count % 60).toString().padStart(2, '0')}
        </Typography>
      </Stack>
    </>
  )
}

//#region Title
const TitleOffer = ({ total }: { total: number }) => {
  return (
    <Typography
      sx={{
        fontSize: { xs: '0.875rem', md: '1rem', xxl: '1.125rem' },
        fontWeight: 300,
        color: 'inherit',
        lineHeight: 1.4,
      }}
    >
      Bạn chỉ cần bỏ ra thêm{' '}
      <Box component={'span'} sx={{ color: 'success.main', fontWeight: 600 }}>
        {getVND(total, 'Đ')}
      </Box>{' '}
      để sỡ hữu trọn bộ ưu đãi này!
    </Typography>
  )
}

//#region Product item
export const ProductItem = ({ item }: { item: TProductItem }) => {
  const t = useTranslations()
  return (
    <Stack direction={'row'} alignItems={'center'} spacing={'12px'}>
      <Box
        sx={{
          width: {
            xs: '94px',
            sm: '72px',
            md: '94px',
          },
          height: 'auto',
          aspectRatio: '1/1',
          background: '#D1D5D6',
          borderRadius: '12px',
          flexShrink: 0,
          overflow: 'hidden',
        }}
      >
        <Link href={item?.link}>
          <Image
            src={item?.product_image}
            alt={item?.product_name || ''}
            width={80}
            height={80}
            sizes="(max-width: 768px) 20vw, 50vw"
            quality={90}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </Link>
      </Box>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems={{ xs: 'flex-start', sm: 'center' }}
        gap={{ xs: 0, sm: 1, md: 2 }}
        sx={{ fontSize: { xs: '0.75rem', md: '0.875rem' }, fontWeight: 300 }}
      >
        <Stack
          gap={{ xs: 0, sm: 0.5 }}
          sx={{
            flexGrow: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: 'inherit',
              fontWeight: 600,
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              lineHeight: 1.4,
            }}
          >
            <Link href={item?.link}>{item?.product_name}</Link>
          </Typography>
          <Box>
            {t('Product.quantity')}: {item?.add_qty} cái
          </Box>
          {item?.attributes && item?.attributes?.length > 0 && (
            <Box>{item?.attributes?.map((attr) => `${attr?.label}: ${attr?.value}`).join(' - ')}</Box>
          )}
        </Stack>
        <Stack
          gap={0.5}
          direction={{ xs: 'row-reverse', sm: 'column' }}
          alignItems={{ xs: 'center', sm: 'flex-end' }}
        >
          {item?.checkout_price !== item?.final_price && (
            <Typography
              fontSize={'0.86em'}
              fontWeight={300}
              sx={{ textDecoration: ' line-through', color: '#BBBBBA' }}
            >
              {getVND(item?.checkout_price, 'Đ')}
            </Typography>
          )}
          <Typography fontSize={'1.3em'} fontWeight={600}>
            {getVND(item?.final_price, 'Đ')}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  )
}
